export default __webpack_public_path__ + "static/media/reactflix_logo.b227b2ad.png";